export const TRANSLATION_NAME_SPACES = {
    DEFAULT: 'default-translations',
    CUSTOM: 'custom-translations',
    DEFAULT_FALLBACK: 'default-fallback-translations',
    CUSTOM_FALLBACK: 'custom-fallback-translations'
};
